(function () {'use strict';}());

angular.module('app').filter('reflectionResponse', function() {
    return function(listing,id) {
    	if(!listing) return listing;
        var trace = angular.trace;
    	var results = [];

    	for(var i = 0, count = listing.length; i < count; i++)
    	{
            var item = listing[i];
            if(item.id === id) results.push(item);
    	}

    	return results;
    };
});